import { render } from "./pharmacysetting.vue?vue&type=template&id=d338bfe0"
import script from "./pharmacysetting.vue?vue&type=script&lang=js"
export * from "./pharmacysetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__